export function isFeatureEnabled () {
  return !!INKIVE.C.FEATURE_FLAG?.extended_editing?.includes?.('ai_write');
}

export function isEditingAllowed () {
  const isDesygner = INKIVE.Helpers.isDesygnerProject();
  const isEnabled = isFeatureEnabled();

  if (isDesygner) {
    return isEnabled
      ? INKIVE.UserInfoFactory.isProPaidUser()
      : isEnabled;
  }

  const permissions = INKIVE.UserInfoFactory.getPermissions();
  return permissions?.templates_update;
}

export function isPreviewAllowed () {
  const isDesygner = INKIVE.Helpers.isDesygnerProject();
  const isWeBrandProject = INKIVE.Helpers.isWeBrandProject();
  const isEnabled = isFeatureEnabled();

  if (isDesygner) return true;
  if(isWeBrandProject || !isEnabled) return isEnabled ?? true;

  return isEditingAllowed() ?? true;
}
